import DelData from '../cost/DelData'

export default function EntrepotDelData(props:any) {
  return (
    <DelData data={{dataInsert:"entrepot"}}></DelData>
  )
}
